module.exports = __webpack_public_path__ + "d4c64ceaa7743ceacf314452b3166e56.pdf";